import { useOrdersApi } from '@pages/billing/payment-history'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useOrdersApi().fetchOrders()
})
